import { useTranslation } from "react-i18next";
import { stdObject } from "../../../data/types/stdObject";
import {
  useMainContext,
  useStationeryContext,
} from "../../../context/MainContext";
import { SetStateAction } from "react";
import { convertPaperValue } from "../../../screens/MainFrame/functions/stationery/convertPaperValue";
import { handleInputValue } from "../../../utils/handleInputValue";
import {
  paperValueToInches,
  stationeryNumbers,
} from "../../../data/stationery";

export default function useStationeryModal() {
  const { t } = useTranslation();
  const { staValues, setStaValues } = useMainContext();
  const { isPrint, paperData, handleActive } = useStationeryContext();

  const selectRow = (e: stdObject, value: SetStateAction<string>) =>
    isPrint
      ? e.onChange(Number(value))
      : convertPaperValue(e.code, handleInputValue(e.type, value), {
          staValues,
          setStaValues,
          handleActive,
        });

  const inputTypeValid = (e: stdObject) =>
    stationeryNumbers.includes(e.code) ? "number" : e.type;

  const inputValueValid = (code: string) =>
    isPrint
      ? paperData.index
      : stationeryNumbers.includes(code)
        ? paperValueToInches(paperData.data[code])
        : paperData.data[code];

  const suffixType = (e: stdObject) =>
    stationeryNumbers.includes(e.code) ? t("p.inches") : e.suffix;

  const innerStyleType = (e: stdObject) =>
    stationeryNumbers.includes(e.code) ? { width: 60 } : e.innerStyle;

  return {
    selectRow,
    inputTypeValid,
    inputValueValid,
    suffixType,
    innerStyleType,
  };
}
